import { render, staticRenderFns } from "./opposite.vue?vue&type=template&id=4487770c&scoped=true&"
import script from "./opposite.vue?vue&type=script&lang=js&"
export * from "./opposite.vue?vue&type=script&lang=js&"
import style0 from "./opposite.vue?vue&type=style&index=0&id=4487770c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4487770c",
  null
  
)

export default component.exports